export const augustAbbreviatedLowercase = "dqa";
export default {augustAbbreviatedLowercase};